import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import routes from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes
});

router.beforeEach((to, from, next) => {
  // console.log(to)
  if (to.path == "/logout") {
    store.dispatch("auth/logout");
    next("/login");
  }

  if (to.name == "login" && store.getters["auth/isLoggedIn"]) {
    next("/");
  } else if (store.getters["auth/isLoggedIn"] || to.name == "login") {
    next();
  } else {
    next("/login");
  }
});

export default router;
